import m from 'mithril'

const constraints = {}

class Conditions {
    constructor(args) {
        args = (args) ? args : {};
        this.id = args.id || '';
        this.houseId = args.houseId || 0
        this.claimValues = args.claimValues || []
    }

    static get data() {
        return _data
    }

    static get() {
        return m.request({
            method: 'GET',
            url: `${window.BASE_URL}/RentHouse/cliam/`,
        })
    }

    static load(id) {
        return m.request({
            method: 'GET',
            url: `${window.BASE_URL}/RentHouse/Get/conditions/${id}`,
        })
    }

    static remove(id) {
        return m.request({
            method: 'DELETE',
            url: `${window.BASE_URL}/api/roles/${id}`
        })
    }

    checkAuth(claim) {
        let query = claim.toUpperCase();
        const filterItems = this.claimValues.filter(item => item.toUpperCase().indexOf(query) >= 0);
        return filterItems.length > 0
    }

    toggleAuth(claim) {
        let query = claim.toUpperCase();
        const filterIndex = this.claimValues.findIndex((item) => {
            return item == query
        })
        if (~filterIndex) {
            return this.claimValues.splice(filterIndex, 1)
        }

        this.claimValues.push(query)
    }

    save() {
        return m.request({
            method: 'PUT',
            url: `${window.BASE_URL}/RentHouse/Save/conditions/${this.houseId}`,
            data: this.claimValues
        })
    }
}

export default Conditions